import { Middleware, isRejectedWithValue } from "@reduxjs/toolkit";
import { isErrorMessage } from "@sscs/types";
import { Toast } from "@sscs/ui";
import { PROJECTS_ENDPOINT, STORED_URL_DATA } from "Constants";

const silentErrorUrls = [
  `${PROJECTS_ENDPOINT}/projects`,
  `${PROJECTS_ENDPOINT}/packages`,
  `${PROJECTS_ENDPOINT}/versions`,
];

function isErrorFromStoredData(
  url: string | undefined,
  status: number,
): boolean {
  if (!url) return false;

  if (status === 404) return false;

  if (!silentErrorUrls.some((item) => url?.includes(`/api${item}`)))
    return false;

  return STORED_URL_DATA.some((item) => {
    const restored = localStorage.getItem(item);

    return restored && url.includes(restored);
  });
}

type FetchErrorAction = {
  payload: {
    status: number;
  };
  meta?: {
    arg?: {
      endpointName: string;
      type: string;
    };
    baseQueryMeta?: {
      request?: {
        url: string;
      };
    };
  };
};

function actionIsFetchErrorAction(action: unknown): action is FetchErrorAction {
  return (
    typeof (action as FetchErrorAction).payload.status === "number" &&
    (action as FetchErrorAction).meta?.arg?.endpointName !== undefined &&
    (action as FetchErrorAction).meta?.arg?.type !== undefined
  );
}

const rtkQueryErrorLogger: Middleware = () => (next) => (action) => {
  // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these matchers!
  if (isRejectedWithValue(action) && actionIsFetchErrorAction(action)) {
    if (
      action.payload &&
      action.payload.status !== 401 &&
      action.meta?.arg?.endpointName !== "login"
    ) {
      // Don't show notification if GET request failed while using data from local storage
      if (
        !isErrorFromStoredData(
          action.meta.baseQueryMeta?.request?.url,
          action.payload.status,
        ) ||
        action.meta.arg?.type !== "query"
      ) {
        Toast.show({
          title: isErrorMessage(action.payload)
            ? action.payload.data.error
            : "Unknown",
          type: "error",
        });
      }
    }
  }

  return next(action);
};

export default rtkQueryErrorLogger;
